import { GAME_ID, REDUX_ACTIONS, panelContainerTypes } from '../../../data/constants';

const initialState = {
  typeOfContainer: panelContainerTypes.GRID,
};

const panelToggleReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_TYPE_OF_CONTAINER:
      return {
        ...state,
        typeOfContainer: payload,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default panelToggleReducer;
